import { MessageCircle } from "lucide-react";
import { getPublicFileUrl } from "@/lib/api";
import { usePublicLang } from "@/contexts/PublicLangContext";
import ScrollReveal from "./ScrollReveal";
import { LANDING } from "@/constants/testIds";

// Fix AZ (2026-10-30): "agregar la información de los profesionales" y "hacer visible el botón de WhatsApp también en
// esta sección" (pedido de la clínica sobre la página web). Muestra las profesionales marcadas en Profesionales >
// "Mostrar en la página web". Sin ninguna marcada, la sección no aparece.
export default function TeamSection({ team, clinic }) {
  const { t } = usePublicLang();
  if (!team || team.length === 0) return null;

  const number = (clinic.public_whatsapp_help_number || clinic.whatsapp_number || "").replace(/[^\d]/g, "");
  const whatsappHref = number ? `https://wa.me/${number}?text=${encodeURIComponent(t("landing.team.whatsappMessage"))}` : null;

  return (
    <section id="equipo" className="py-20 md:py-28 px-5 bg-white" data-testid={LANDING.teamSection}>
      <div className="max-w-6xl mx-auto">
        <ScrollReveal className="text-center mb-12 md:mb-16">
          <p className="text-xs uppercase tracking-[0.2em] font-medium text-[var(--brand-primary)] mb-3">{t("landing.nav.team")}</p>
          <h2 className="font-serif text-3xl md:text-5xl tracking-tight text-[#292522]">{t("landing.team.sectionTitle")}</h2>
          <p className="text-base text-[#6B6058] mt-3">{t("landing.team.subtitle")}</p>
        </ScrollReveal>

        <div className={`grid gap-8 sm:grid-cols-2 ${team.length >= 3 ? "lg:grid-cols-3" : ""} ${team.length <= 2 ? "max-w-3xl mx-auto" : ""}`}>
          {team.map((p, idx) => (
            <ScrollReveal key={p.id} delay={idx * 0.08}>
              <div className="text-center" data-testid={`${LANDING.teamCardPrefix}${p.id}`}>
                <div className="rounded-2xl overflow-hidden aspect-[4/5] mb-5 bg-[#F3EDE4] border border-[rgba(185,154,98,0.25)]">
                  {p.photo_url ? (
                    <img src={getPublicFileUrl(p.photo_url)} alt={p.name} className="w-full h-full object-cover" loading="lazy" />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center font-serif text-5xl text-[var(--brand-primary)]">
                      {p.name.split(" ").filter(Boolean).slice(0, 2).map((w) => w[0]).join("")}
                    </div>
                  )}
                </div>
                <h3 className="font-serif text-2xl text-[#292522] leading-tight">{p.name}</h3>
                {p.specialty && <p className="text-xs uppercase tracking-[0.16em] font-medium text-[var(--brand-primary)] mt-2">{p.specialty}</p>}
              </div>
            </ScrollReveal>
          ))}
        </div>

        {whatsappHref && (
          <ScrollReveal className="flex justify-center mt-12">
            <a
              href={whatsappHref}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 bg-[#25D366] text-white px-6 py-3 rounded-full shadow-lg hover:scale-105 active:scale-95 transition-transform text-sm font-medium"
              data-testid={LANDING.teamWhatsapp}
            >
              <MessageCircle className="w-5 h-5" /> {t("landing.team.whatsapp")}
            </a>
          </ScrollReveal>
        )}
      </div>
    </section>
  );
}
